import React from "react";

const Dashboard = React.lazy(() => import("./dashboard"));

export {
  Dashboard,
};
